meedy.factory('meedy.availabilityRuleService', ['$q', '$rootScope', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $rootScope, baseService, objectHelper, config) {

        function AvailabilityRuleService() {

            this.getAvailabilityRuleOccurences = function(criteria) {
                return baseService.post(config.API_URL + '/availabilityRule/getAvailabilityRuleOccurrences', criteria).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AvailabilityRuleOccurrenceMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createAvailabilityRule = function(availabilityRule) {
                availabilityRule = objectHelper.convertDatesToTimes(availabilityRule);
                return baseService.post(config.API_URL + '/availabilityRule/createAvailabilityRule', availabilityRule).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AvailabilityRuleMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateAvailabilityRule = function(availabilityRule) {
                availabilityRule = objectHelper.convertDatesToTimes(availabilityRule);
                return baseService.post(config.API_URL + '/availabilityRule/updateAvailabilityRule', availabilityRule).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AvailabilityRuleMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAvailabilityRuleById = function(id) {
                return baseService.get(config.API_URL + '/availabilityRule/getAvailabilityRuleById/' + id).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, AvailabilityRuleMeedyVO);
                        return objectHelper.convertTimesToDates(data);
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAvailabilityRule = function(criteria) {
                return baseService.post(config.API_URL + '/availabilityRule/getAvailabilityRule', criteria).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AvailabilityRuleMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteAvailabilityRule = function(availabilityRule) {
                return baseService.post(config.API_URL + '/availabilityRule/deleteAvailabilityRule', availabilityRule).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getNearestAvailabilityRuleCacheOccurence = function(criteria) {
                var request = objectHelper.convertDatesToTimes(criteria);
                return baseService.post(config.API_URL + '/availabilityRule/getNearestAvailabilityRuleCacheOccurrence', request).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AvailabilityRuleOccurrenceCacheMeedyVO);
                        data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getNearestAvailabilityRuleCacheOccurrenceForAbc = function(criteria) {
                var request = objectHelper.convertDatesToTimes(criteria);
                return baseService.post(config.API_URL + '/availabilityRule/getNearestAvailabilityRuleCacheOccurrenceForAbc', request).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AvailabilityRuleOccurrenceCacheMeedyVO);
                        data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAvailabilityRuleOccurences = function(criteria) {
                return baseService.post(config.API_URL + '/availabilityRule/getAvailabilityRuleOccurrences', criteria).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AvailabilityRuleOccurrenceMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAvailabilityRules = function() {
                return baseService.post(config.API_URL + '/availabilityRule/getAvailabilityRules').then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, UserAvailabilityRulesMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.checkCollisions = function(availabilityRule) {
                availabilityRule = objectHelper.convertDatesToTimes(availabilityRule);
                return baseService.post(config.API_URL + '/availabilityRule/checkCollisionsForAbc', availabilityRule).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createSingleOccurrence = function(slotRequest) {
                return baseService.post(config.API_URL + '/availabilityRule/singleOccurrence', slotRequest).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.removeSingleOccurrence = function(idResource, slotWrapper) {
                return baseService.post(config.API_URL + '/availabilityRule/removeSingleOccurrence/' + idResource, slotWrapper).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };


        }

        return new AvailabilityRuleService();
    }
]);
